module.exports = __webpack_public_path__ + "zhifubao-img.jpg?faa6be1be73f41454448b296734189aa";


//////////////////
// WEBPACK FOOTER
// ./src/Payment/images/zhifubao-img.jpg
// module id = 259
// module chunks = 0